import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DialogHeader from "../../../../../../common/components/functional/dialogs/DialogHeader";
import { formatDateStringForUI } from "../../../helpers/commonUtils";

interface Props {
  pricingValidFromDate: string;
  selectedItemName: string;
  workLocationName: string;
  handleClose: () => void;
}

const PricingFormModalHeader = ({
  pricingValidFromDate,
  selectedItemName,
  workLocationName,
  handleClose,
}: Props) => {
  const { t } = useTranslation("customers");

  const pricingTitle = `${t("contract.pricing")} ${formatDateStringForUI(
    pricingValidFromDate,
  )} - ${selectedItemName}`;

  const TitleComponent = (
    <Box display="flex" alignItems="center" gap={workLocationName ? "1rem" : 0}>
      <Typography variant="header" fontSize="22px" fontWeight="600">
        {pricingTitle}
      </Typography>
      <Typography>{workLocationName}</Typography>
    </Box>
  );

  return <DialogHeader title={TitleComponent} onClose={handleClose} />;
};

export default PricingFormModalHeader;
